interface FormGridProps {
  cols?: 1 | 2;
  gap?: 'sm' | 'md';
  children: React.ReactNode;
  className?: string;
}

/**
 * 两列表单栅格。
 * cols=1 全宽（textarea、单行长字段）；cols=2 成对字段（联系人/电话）。
 */
export default function FormGrid({ cols = 2, gap = 'md', children, className = '' }: FormGridProps) {
  const gapClass = gap === 'sm' ? 'gap-3' : 'gap-4';
  const colsClass = cols === 2 ? 'md:grid-cols-2' : '';
  return <div className={`grid ${gapClass} ${colsClass} ${className}`}>{children}</div>;
}

interface FormFieldProps {
  label: string;
  required?: boolean;
  error?: string;
  hint?: string;
  children: React.ReactNode;
}

/**
 * 标签 + 控件 + 错误/提示。
 *
 * 设计系统（DESIGN.md §10）：
 * - label 颜色从 slate-700 换到 walnut-700（暖调）
 * - required 星号用 danger 色（不是 red-500，走 token）
 * - hint 与 error 同位置互斥显示，避免两行堆叠
 */
export function FormField({ label, required, error, hint, children }: FormFieldProps) {
  return (
    <div className="space-y-1.5">
      <label className="block text-xs font-medium text-walnut-700">
        {label}
        {required ? <span className="ml-1 text-danger">*</span> : null}
      </label>
      {children}
      {error ? <p className="text-xs text-danger">{error}</p> : null}
      {hint && !error ? <p className="text-xs text-oak-500">{hint}</p> : null}
    </div>
  );
}
